(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // The sticky-header element itself has the header-wrapper class
      this.headerWrapper = this.classList.contains('header-wrapper') ? this : this.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.checkForBannerSection();
      
      // Throttle variables for banner opacity updates
      this.bannerOpacityUpdatePending = false;
      this.lastBannerOpacityUpdate = 0;
      this.bannerOpacityThrottleDelay = 16; // ~60fps

      // Initialize banner opacity on page load
      this.updateBannerOpacity(window.pageYOffset || document.documentElement.scrollTop);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    checkForBannerSection() {
      // Check if we're on the home page
      if (window.location.pathname === '/' || window.location.pathname === '/index') {
        // Always add transparent class on index page
        if (this.headerWrapper) {
          this.headerWrapper.classList.add('header-wrapper--transparent');
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Update banner opacity on index page (throttled)
      this.updateBannerOpacity(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateBannerOpacity(scrollTop) {
      // Throttle updates to prevent excessive calls
      const now = Date.now();
      if (this.bannerOpacityUpdatePending) {
        return;
      }
      
      if (now - this.lastBannerOpacityUpdate < this.bannerOpacityThrottleDelay) {
        this.bannerOpacityUpdatePending = true;
        requestAnimationFrame(() => {
          this.bannerOpacityUpdatePending = false;
          this.updateBannerOpacity(scrollTop);
        });
        return;
      }
      this.lastBannerOpacityUpdate = now;

      // Only apply on index page
      if (window.location.pathname !== '/' && window.location.pathname !== '/index') {
        return;
      }

      const banner = this.querySelector('.header__banner') || document.querySelector('.header__banner');
      // Ensure headerWrapper is set (it's the sticky-header element itself)
      if (!this.headerWrapper) {
        this.headerWrapper = this.classList.contains('header-wrapper') ? this : this.querySelector('.header-wrapper');
      }
      
      if (!banner || !this.headerWrapper) {
        return;
      }

      // Ensure transparent class is added on index page
      if (!this.headerWrapper.classList.contains('header-wrapper--transparent')) {
        this.headerWrapper.classList.add('header-wrapper--transparent');
      }
      
      let opacity;
      
      // Priority 1: At the very top, opacity is always 0
      if (scrollTop === 0) {
        opacity = '0';
      }
      // Priority 2: If sticky header is revealed (scrolling up and visible), set opacity to 1
      else if (this.header.classList.contains('shopify-section-header-sticky') && 
               !this.header.classList.contains('shopify-section-header-hidden')) {
        opacity = '1';
      }
      // Priority 3: When scrolling down or header is hidden, keep opacity at 0
      else {
        opacity = '0';
      }
      
      banner.style.opacity = opacity;
      
      // Toggle class based on opacity for CSS styling
      if (opacity === '1') {
        this.headerWrapper.classList.add('banner-visible');
      } else {
        this.headerWrapper.classList.remove('banner-visible');
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // When sticky header is revealed, set banner opacity to 1
      this.updateBannerOpacity(window.pageYOffset || document.documentElement.scrollTop);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
